<template>
  <div class="banner">
    <div class="banner-container">
      <studio-logo disableClick/>
      <div class="social-medias">
        <a
          class="social"
          v-for="social in socials"
          :key="social.name"
          :href="social.url"
          target="_blank"
        >
          <fa-icon :icon="['fab', social.icon]" :style="{'color': 'white'}"/>
        </a>
      </div>
      <div class="navigation">
        <div class="nav-btn" :class="{selected: isViewSelected('games')}">
          <router-link to="/games">
            GAMES
          </router-link>
        </div>
        <div class="nav-btn" :class="{selected: isViewSelected('about')}">
          <router-link to="/about">
            ABOUT
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SOCIALS from '@/constants/social-media.js'
import StudioLogo from '@/components/studio-logo.vue'
export default {
  components:{
    StudioLogo,
  },
  data() { 
    return {
      socials: [
        SOCIALS.SOCIALS.TWITTER,
        SOCIALS.SOCIALS.REDDIT,
        SOCIALS.SOCIALS.TWITCH,
      ]
    }
  },
  methods: {
    isViewSelected(view) {
      return this.$route.path === `/${view}`
    }
  },
}
</script>

<style scoped lang="scss">
$padding-side: 2vw;
$padding-vertical: 10px;
.banner {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: rgba(black, 0.90);
  margin-bottom: 3px;
}
.banner-container {
  width: 55%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  padding-left: $padding-side;
  padding-right: $padding-side;
  padding-top: $padding-vertical;
  padding-bottom: $padding-vertical;

  .social-medias {
    font-size: 30px;
    .social {
      opacity: 0.5;
      transition: 0.2s all;
      margin-left: 5px;
      margin-right: 5px;

      &:hover {
        opacity: 1;
      }
    }
  }
}

.navigation {

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-size: 20px;

  .nav-btn {

    color: rgba(white, 0.5) !important;
    a {
      text-decoration: none !important;
      color: inherit;
    }

    &:not(:last-child) {
      padding-right:10px;
      border-right: 2px solid rgba(white, 0.25);
    }
    &:not(:first-child) {
      margin-left: 10px;
    }

    &.selected {
      color: rgba(white, 1) !important;

      a {
        cursor: default;
      }
    }
    &:hover:not(.selected) {
      color: rgba(white, 0.75) !important;
    }
  }
}

@media only screen and (max-width: 1600px) {
  .banner-container {
    width: 70%;
  }
}
@media only screen and (max-width: 962px) {
  .banner-container {
    width: 90%;
  }
}
@media only screen and (max-width: 600px) {
  .navigation {
    font-size: 15px !important;
  }
  .social-medias {
    font-size: 20px !important;
  }
}
</style>